import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'home',
      meta: {
        layout: 'main',
        title: 'public-search-link',
      },

      redirect: { name: 'home-search', params: {search: 'active'} },
      component: () => import('@/pages/HomePage'),

      children: [
        {
          path: 'search/:search',
          name: 'home-search',
          meta: { layout: 'main' },
          component: () => import('@/components/public-search/Main'),
          props: (route) => ({
            search: route.params.search
          })
        }
      ]
    },

    {
      path: '/signup',
      name: 'signup',
      meta: { layout: 'main' },
      component: () => import('@/pages/SignupPage')
    },

    {
      path: '/confirm',
      name: 'confirm',
      meta: { layout: 'main' },
      component: () => import('@/pages/ConfirmPage')
    },

    {
      path: '/account',
      name: 'account',

      meta: {
        layout: 'main',
        autorizedOnly: true,
        title: 'personal-data-link',

        breadcrumbs: true
      },

      component: () => import('@/pages/PersonalDataPage'),
      redirect: { name: 'personal-data' },

      children: [
        {
          name: 'personal-data',
          path: 'personal-data',
          meta: {
            title: 'account.personal-data',
            layout: 'main',
            breadcrumbs: true
          },
          component: () => import('@/components/personal-data/personal-info/PersonalData')
        },
        {
          path: 'contractor',
          meta: {
            title: 'account.contractor',
            breadcrumbs: true
          },
          component: () => import('@/components/personal-data/contractor/Contractor')
        },
        {
          path: 'accreditation',
          name: 'own-accreditation',
          meta: {
            title: 'account.accreditation',
            breadcrumbs: true
          },
          component: () => import('@/components/personal-data/accreditation/Accreditation')
        },
        {
          path: 'accreditation-history',
          meta: {
            title: 'account.accreditation-history',
            breadcrumbs: true
          },
          component: () => import('@/components/personal-data/accreditation/AccreditationHistory')
        },
        {
          path: 'digital-signature',
          meta: {
            title: 'account.digital-signature',
            breadcrumbs: true
          },
          component: () => import('@/components/personal-data/digital-signature/DigitalSignature')
        },

        {
          meta: {
            breadcrumbs: {
              computed: true,
              component: () => import('@/components/admin/users/UserDetails')
            }
          },
          name: 'normal-users-account',
          path: ':userId/:tab',
          component: () => import('@/components/admin/users/UserDetails')
        }
      ]
    },

    {
      path: '/purchases',
      name: 'purchases',
      component: () => import('@/pages/PurchasesPage'),
      redirect: { name: 'purchases-lots' },
      meta: { layout: 'main', autorizedOnly: true },

      children: [
        {
          name: 'purchases-lots',
          path: 'lots',
          meta: {layout: 'main', title: 'purchases-link'},
          redirect: {name: 'purchases-lots-search'},
          component: () => import('@/components/purchases/lots/Main'),

          children: [
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-lots-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/purchases/lots/Search')
            },
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-lot-details',
              path: ':lotId/:tab',
              component: () => import('@/components/purchases/lot-details/Main')
            }
          ]
        },

        {
          name: 'retend',
          path: 'retend',
          meta: {layout: 'main', title: 'purchases-link'},
          component: () => import('@/components/purchases/retend/Main'),

          children: [
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'retend-details',
              path: ':lotId/:retendNum/:tab',
              component: () => import('@/components/purchases/retend/Details')
            }
          ]
        },

        {
          name: 'purchases-mentioned-lots',
          path: 'mentioned',
          meta: {layout: 'main', title: 'purchases-link'},
          redirect: {name: 'purchases-purchases-lots-search'},
          component: () => import('@/components/purchases/lots/Main'),

          children: [
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-purchases-lots-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/purchases/mentioned-lots/Search')
            }
          ]
        },

        {
          name: 'purchases-tenders',
          path: 'tenders',
          meta: {layout: 'main', title: 'purchases-link'},
          redirect: {name: 'purchases-tenders-search'},
          component: () => import('@/components/purchases/tenders/Main'),

          children: [
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-tenders-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/purchases/tenders/Search')
            },
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-tender-details',
              path: ':tenderId/:tab',
              component: () => import('@/components/purchases/tender-details/Main')
            }
          ]
        },

        {
          name: 'purchases-favorites',
          path: 'favorites',
          meta: {layout: 'main', title: 'purchases-link'},
          component: () => import('@/components/purchases/favorites/Main')
        },

        {
          name: 'purchases-my-lots',
          path: 'public',
          meta: { layout: 'main', title: 'purchases-link' },
          //redirect: {name: 'purchases-my-lots-search'},
          component: () => import('@/components/purchases/my-lots/Main'),

          children: [
            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-my-lots-details',
              path: 'lot/:lotId/:tab',
              component: () => import('@/components/purchases/my-lot-details/Main')
            },

            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-public-tender-details',
              path: 'tender/:tenderId/:tab',
              component: () => import('@/components/purchases/public-tender-details/Main')
            },

            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-public-lot-alien-bid',
              path: 'lot/:lotId/:requestId/:bidId/:tab',
              component: () => import('@/components/purchases/my-lot-details/MainAlien')
            },

            {
              meta: { layout: 'main', title: 'purchases-link' },
              name: 'purchases-public-lot-alien-bid-history',
              path: 'lot/:lotId/:requestId/history/:historyId/:bidId/:tab',
              component: () => import('@/components/purchases/my-lot-details/MainAlienBidHistory')
            }
          ]
        },

        {
          name: 'purchases-reports',
          path: 'reports',

          meta: {
            breadcrumbs: {
              title: 'admin.reports'
            }
          },

          component: () => import('@/components/admin/reports/Main'),
        },
      ]
    },

    {
      path: '/news',
      name: 'news',
      redirect: { name: 'news-list', params: { folder: 'active' } },
      component: () => import('@/pages/NewsPage'),

      meta: {
        layout: 'main',
        title: 'news-link',
        breadcrumbs: true
      },

      children: [
        {
          meta: {
            layout: 'main'
          },
          name: 'news-create',
          path: 'create',
          component: () => import('@/components/news/CreateNews')
        },

        {
          meta: {
            layout: 'main'
          },
          name: 'news-list',
          path: 'feed',
          component: () => import('@/components/news/NewsList'),
          props: (route) => ({
            showArchive: route.query.folder === 'archive',
            page: +route.query.page || 1,
            pageSize: +route.query.pageSize || 10
          })
        },

        {
          meta: {
            layout: 'main'
          },
          name: 'news-overview',
          path: ':id',
          component: () => import('@/components/news/NewsItemOverview')
        }
      ]
    },

    {
      path: '/messages',
      name: 'messages',
      component: () => import('@/pages/MessagesPage'),
      redirect: {name: 'messages-inbox'},
      meta: {
        layout: 'main',
        autorizedOnly: true,
        title: 'msgs-and-subscriptions-link',
        breadcrumbs: true
      },

      children: [
        {
          name: 'messages-inbox',
          path: 'inbox',
          meta: {
            title: 'messages.inbox',
            breadcrumbs: true
          },
          component: () => import('@/components/messages/inbox/Main'),
          redirect: {name: 'messages-inbox-filtered', params: {kind: 'all'}},

          children: [
            {
              name: 'messages-inbox-filtered',
              path: ':kind',
              component: () => import('@/components/messages/inbox/Messages'),

              props: (route) => ({
                kind: route.params.kind
              })
            }
          ]
        },

        {
          name: 'messages-sent',
          path: 'sent',
          meta: {
            title: 'messages.sent',
            breadcrumbs: true
          },
          component: () => import('@/components/messages/sent/Main'),
          redirect: {name: 'messages-sent-filtered', params: {kind: 'all'}},

          children: [
            {
              name: 'messages-sent-filtered',
              path: ':kind',
              component: () => import('@/components/messages/sent/Messages'),

              props: (route) => ({
                kind: route.params.kind
              })
            }
          ]
        },

        {
          name: 'messages-trash',
          path: 'trash',
          meta: {
            title: 'messages.trash',
            breadcrumbs: true
          },
          component: () => import('@/components/messages/trash/Main')
        },

        {
          name: 'messages-settings-messages',
          path: 'options/messages',
          meta: {
            title: 'messages.configure-messages',
            breadcrumbs: true
          },
          component: () => import('@/components/messages/settings/messages/Main')
        },


        {
          path: 'options/subscriptions',

          redirect: {
            name: 'messages-settings-subscriptions',

            params: {
              tab: 'categories'
            }
          },

          meta: {
            title: 'messages.configure-subscriptions',
            breadcrumbs: true
          },

          component: () => import('@/components/messages/settings/subscriptions/Main'),

          children: [
            {
              name: 'messages-settings-subscriptions',
              path: ':tab',

              component: () => import('@/components/messages/settings/subscriptions/Main')
            }
          ]
        }
      ]
    },

    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/pages/AdminPage'),

      redirect: {
        name: 'admin-accreditations',
        autorizedOnly: true
      },

      meta: {
        layout: 'main',
        title: 'admin-link',
        breadcrumbs: true
      },

      children: [
        // {
        //   name: 'admin-catalogs',
        //   path: 'catalogs',
        //
        //   meta: {
        //     layout: 'main',
        //     title: 'catalogs-link',
        //     breadcrumbs: true
        //   },
        //
        //   component: () => import('@/components/admin/catalogs/MainSingleCatalog'),
        //
        //   children: [
        //     {
        //       meta: { breadcrumbs: true },
        //       name: 'admin-catalogs-catalog',
        //       path: 'catalog',
        //       component: () => import('@/components/admin/catalogs/MainSingleCatalog'),
        //     }
        //   ]
        // },

        {
          name: 'admin-catalogs-catalog',
          path: 'catalogs/catalog',

          meta: {
            layout: 'main',
            title: 'catalogs-link',
            breadcrumbs: true
          },

          component: () => import('@/components/admin/catalogs/MainSingleCatalog')
        },

        {
          name: 'admin-accreditations',
          path: 'accreditations',
          meta: {
            breadcrumbs: {
              title: 'admin.accreditations'
            }
          },
          redirect: { name: 'admin-accreditations-search' },
          component: () => import('@/components/admin/accreditations/Accreditations'),

          children: [
            {
              meta: { breadcrumbs: true, details: 'admin-accreditations-account' },
              name: 'admin-accreditations-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/admin/accreditations/AccreditationsSearch')
            },
            {
              meta: { breadcrumbs: true },
              name: 'admin-accreditations-account',
              path: ':userId/:tab',
              component: () => import('@/components/admin/users/UserDetails')
            }
          ]
        },

        {
          name: 'admin-users',
          path: 'users',
          meta: {
            breadcrumbs: {
              title: 'admin.users'
            }
          },
          redirect: { name: 'admin-users-search' },
          component: () => import('@/components/admin/users/Users'),

          children: [
            {
              meta: { breadcrumbs: true, details: 'admin-users-account' },
              name: 'admin-users-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/admin/users/search/UsersSearch')
            },

            {
              meta: { breadcrumbs: true },
              name: 'admin-users-account',
              path: ':userId/:tab',
              component: () => import('@/components/admin/users/UserDetails')
            }
          ]
        },

        {
          name: 'admin-contractors',
          path: 'contractors',
          meta: {
            breadcrumbs: {
              title: 'admin.contractors'
            }
          },
          redirect: { name: 'admin-contractors-search' },
          component: () => import('@/components/admin/contractors/Contractors'),

          children: [
            {
              meta: { breadcrumbs: true },
              name: 'admin-contractors-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/admin/contractors/ContractorsSearch')
            },
            {
              meta: { breadcrumbs: true },
              name: 'admin-contractor-account',
              path: ':userId/:tab',
              component: () => import('@/components/admin/users/UserDetails')
            }
          ]
        },

        {
          name: 'admin-lots',
          path: 'lots',
          meta: {
            breadcrumbs: {
              title: 'admin.lots'
            }
          },
          redirect: { name: 'admin-lots-search' },
          component: () => import('@/components/purchases/lots/Main'),

          children: [
            {
              meta: { breadcrumbs: true },
              name: 'admin-lots-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/purchases/lots/Search')
            },
            {
              meta: { breadcrumbs: true },
              name: 'admin-lots-details',
              path: ':lotId/:tab',
              component: () => import('@/components/purchases/lot-details/Main')
            }
          ]
        },

        {
          name: 'admin-settings',
          path: 'settings',

          meta: {
            breadcrumbs: {
              title: 'admin.settings'
            }
          },

          component: () => import('@/components/admin/settings/Main'),
        }
      ]
    },

    {
      path: '/catalogs',
      name: 'catalogs',
      component: () => import('@/pages/CatalogsPage'),

      redirect: {
        // name: 'catalogs-catalog',
        // query: { catalog: 'nomenclature' },
        name: 'catalogs-users',
        autorizedOnly: true
      },

      meta: {
        layout: 'main',
        title: 'catalogs-link',
        breadcrumbs: true
      },

      children: [
        {
          name: 'catalogs-users',
          path: 'users',
          redirect: {
            name: 'catalogs-users-search'
          },

          meta: {
            breadcrumbs: {
              title: 'admin.users'
            }
          },

          components: {
            default: () => import('@/components/admin/users/Users'),
            //results: () => import('@/components/admin/users/UsersSearchResults')
          },

          children: [
            {
              meta: {
                search: true,
                details: 'catalogs-users-account'
              },

              name: 'catalogs-users-search',
              path: 'search',
              exact: true,

              components: {
                default: () => import('@/components/admin/users/search/UsersSearch'),
              }
            },

            {
              meta: {
                breadcrumbs: {
                  computed: true,
                  component: () => import('@/components/admin/users/UserDetails')
                }
              },
              name: 'catalogs-users-account',
              path: ':userId/:tab',
              component: () => import('@/components/admin/users/UserDetails')
            }
          ]
        },

        {
          name: 'catalogs-contractors',
          path: 'contractors',
          meta: {
            breadcrumbs: {
              title: 'admin.contractors'
            }
          },
          redirect: { name: 'catalogs-contractors-search' },
          component: () => import('@/components/admin/contractors/Contractors'),

          children: [
            {
              meta: { breadcrumbs: true, details: 'catalogs-users-account' },
              name: 'catalogs-contractors-search',
              path: 'search',
              exact: true,
              component: () => import('@/components/admin/contractors/ContractorsSearch')
            },
            {
              meta: { breadcrumbs: true },
              name: 'catalogs-contractor-account',
              path: ':userId/:tab',
              component: () => import('@/components/admin/users/UserDetails')
            }
          ]
        },

        {
          name: 'catalogs-catalogs',
          path: 'catalogs',

          meta: {
            breadcrumbs: {
              title: 'admin.catalogs'
            }
          },

          component: () => import('@/components/admin/catalogs/Main'),
        },

        {
          name: 'catalogs-catalog',
          path: 'catalog',

          meta: {
            breadcrumbs: {
              title: 'admin.catalogs'
            }
          },

          component: () => import('@/components/admin/catalogs/MainSingleCatalog'),
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const isAuthorized = await store.dispatch('isSessionValid');
  store.commit('setReady');

  if (to.matched.some(r => r.meta.autorizedOnly) && !isAuthorized) {
    next({ name: 'home' });
  }
  else {
    next();
  }
});

export default router;

